export default __webpack_public_path__ + "static/media/plain-sticker-X.b98be6b7.png";